@if (view == true) {
  <div class="container">
    <mat-card  appearance="outlined"  style="height: 70vh" class="mat-card-c" >
      <mat-card-content class="mat-body-1">
        <h2 style="display: flex; justify-content: center;"><strong>Items Alerta Stock Minimo</strong></h2>
        <data-table
          [title]=''
          [columns]='columnsMinStock'
          [configuration]='configurationMinStock'
          [reloadTable]='reloadMinStock'
          [url]='urlGetTablaMinStock'
          [params]='paramsMinStock'
          (internalData)="dataResources($event)">
        </data-table>
      </mat-card-content>
    </mat-card>
    <ng-container  *ngTemplateOutlet="buttons" >
    </ng-container>
  </div>
}


<ng-template #buttons >
  <!-- button -->
  <div  class="button d-flex justify-content-between flex-row">
    <button  class="button-width" color="warn" class="button-save mat-elevation-z5 button-width" mat-raised-button
    (click)="responsePurchaseOrder(resources)">Orden de compra</button>
    <button type="submit" color="primary" class="button-save mat-elevation-z5 button-width " mat-raised-button
    (click)="responseInput(resources)">Generar Entrada</button>
  </div>

</ng-template>





